import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GlobalComponent } from 'src/app/global/global.component';

@Injectable({
  providedIn: 'root'
})
export class AgencySettingsService {   
  constructor(private http: HttpClient, public errorService: ErrorService , public global : GlobalComponent) { }
  
  SaveSettings(settings: any): Observable<any> {
    let url = "api/Settings/SaveCCXWidgetSettings?";
    return this.http.post<any>(url, settings, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getSettings(myParams): Observable<any> {
    let url;
    if(this.global.OnboardingLoginType =='onboardLogin')
      {
         url = "api/Client_Settings/getSettings?";
      }
      else{

         url = "api/Settings/getSettings?";
      }
    return this.http.get<any>(url+myParams, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  generateApikey():Observable<any>{
   let url ='api/Settings/GenerateWidgetAccessKey';
   return this.http.get<any>(url,{observe :'response'}).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
   )
  }

 
}
